var ICONS_DIR = "bouqs-ui-icons";
export var STAGING_CDN = "https://cdn.staging.bouqs.com/storefront-ui/" + ICONS_DIR;
export var PRODUCTION_CDN = "https://cdn.bouqs.com/storefront-ui/" + ICONS_DIR;
export var BOUQS_ICONS = {
  account: {
    file: "account.svg",
    alt: "Account"
  },
  arrowDown: {
    file: "arrow-down.svg",
    alt: "Arrow Down"
  },
  arrowLeft: {
    file: "arrow-left.svg",
    alt: "Arrow Left"
  },
  arrowRight: {
    file: "arrow-right.svg",
    alt: "Arrow Right"
  },
  arrowUp: {
    file: "arrow-up.svg",
    alt: "Arrow Up"
  },
  artisanDesigns: {
    file: "artisan-designs.svg",
    alt: "Artisan Designs"
  },
  basket: {
    file: "basket.svg",
    alt: "Basket"
  },
  bloom: {
    file: "bloom.svg",
    alt: "Bloom"
  },
  bouq: {
    file: "bouq.svg",
    alt: "Bouq"
  },
  bubble: {
    file: "bubble.svg",
    alt: "Bubble"
  },
  calendar: {
    file: "calendar.svg",
    alt: "Calendar"
  },
  calendarDateTime: {
    file: "calendar-date-time.svg",
    alt: "Calendar Date Time"
  },
  calendarDate: {
    file: "calendar-date.svg",
    alt: "Calendar Date"
  },
  calendarRepeat: {
    file: "calendar-repeat.svg",
    alt: "Calendar Repeat"
  },
  checkBox: {
    file: "check-box.svg",
    alt: "Checkbox"
  },
  checkmarkRounded: {
    file: "checkmark-rounded.svg",
    alt: "Checkmark Rounded"
  },
  checkmark: {
    file: "checkmark.svg",
    alt: "Checkmark"
  },
  chevron: {
    file: "chevron.svg",
    alt: "Arrow"
  },
  clock: {
    file: "clock.svg",
    alt: "Clock"
  },
  close: {
    file: "close.svg",
    alt: "Close"
  },
  cut: {
    file: "cut.svg",
    alt: "Cut"
  },
  envelope: {
    file: "envelope.svg",
    alt: "Envelope"
  },
  exclamation: {
    file: "exclamation.svg",
    alt: "Exclamation"
  },
  external: {
    file: "external.svg",
    alt: "External"
  },
  eyedropper: {
    file: "eyedropper.svg",
    alt: "Eyedropper"
  },
  facebook: {
    file: "facebook.svg",
    alt: "Facebook"
  },
  go: {
    file: "go.svg",
    alt: "Go"
  },
  hand: {
    file: "hand.svg",
    alt: "Hand"
  },
  happinessGuaranteed: {
    file: "happiness-guaranteed.svg",
    alt: "Happiness Guaranteed"
  },
  filter: {
    file: "iconFilter.svg",
    alt: "Filter"
  },
  info: {
    file: "info.svg",
    alt: "Info"
  },
  instagram: {
    file: "instagram.svg",
    alt: "Instagram"
  },
  justBecause: {
    file: "just-because.svg",
    alt: "Just Because"
  },
  locationSolid: {
    file: "location-solid.svg",
    alt: "Location"
  },
  location: {
    file: "location.svg",
    alt: "Location"
  },
  logo: {
    file: "logo.svg",
    alt: "Bouqs Logo"
  },
  menu: {
    file: "menu.svg",
    alt: "Menu"
  },
  minus: {
    file: "minus.svg",
    alt: "Minus"
  },
  olapic: {
    file: "olapic.svg",
    alt: "Olapic Logo"
  },
  paper: {
    file: "paper.svg",
    alt: "Paper"
  },
  person: {
    file: "person.svg",
    alt: "Person"
  },
  pinterest: {
    file: "pinterest.svg",
    alt: "Pinterest"
  },
  play: {
    file: "play.svg",
    alt: "Play"
  },
  playWhite: {
    file: "play.svg",
    alt: "Play"
  },
  plus: {
    file: "plus.svg",
    alt: "Plus"
  },
  pointingArrow: {
    file: "pointing-arrow.svg",
    alt: "Arrow"
  },
  prepayBouq: {
    file: "prepay-bouq.svg",
    alt: "Prepay Bouq"
  },
  regularDelivery: {
    file: "regular-delivery.svg",
    alt: "Regular Delivery"
  },
  saleTagAlt: {
    file: "sale-tag-alt.svg",
    alt: "Sale Tag"
  },
  saleTag: {
    file: "sale-tag.svg",
    alt: "Sale Tag"
  },
  save: {
    file: "save.svg",
    alt: "Save"
  },
  search: {
    file: "search.svg",
    alt: "Search"
  },
  shopping: {
    file: "shopping.svg",
    alt: "Shopping"
  },
  sort: {
    file: "sort.svg",
    alt: "Sort"
  },
  specialOccasions: {
    file: "special-occasions.svg",
    alt: "Special Occasions"
  },
  star: {
    file: "star.svg",
    alt: "Star"
  },
  sun: {
    file: "sun.svg",
    alt: "Sun"
  },
  sustainable: {
    file: "sustainable.svg",
    alt: "Sustainable"
  },
  truck: {
    file: "truck.svg",
    alt: "Truck"
  },
  twitter: {
    file: "twitter.svg",
    alt: "Twitter"
  },
  water: {
    file: "water.svg",
    alt: "Water"
  },
  x: {
    file: "x.svg",
    alt: "X"
  },
  youTube: {
    file: "youtube.svg",
    alt: "YouTube"
  }
};
//# sourceMappingURL=url-icons.constants.js.map